import React from "react";
import { Plus } from "lucide-react";

export function PageHeader({ eyebrow, title, description, action, testid }) {
  return (
    <div className="mb-8 flex items-start justify-between flex-wrap gap-4" data-testid={testid}>
      <div>
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#5C5B57] mb-2">{eyebrow}</p>
        <h1 className="font-heading text-4xl sm:text-5xl text-[#2D2C2A] tracking-tight">{title}</h1>
        {description && <p className="text-[#5C5B57] mt-2">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export function AddButton({ onClick, label, testid }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className="inline-flex items-center gap-2 bg-[#8A5A44] text-white hover:bg-[#714835] rounded-xl px-5 py-3 font-medium transition-all hover:-translate-y-0.5 shadow-sm"
    >
      <Plus size={18} strokeWidth={2} /> {label}
    </button>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="text-xs tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-2 block">{label}</label>
      {children}
    </div>
  );
}

export const inputCls = "w-full bg-white border border-[#E6E4DD] rounded-xl px-4 py-2.5 text-[#2D2C2A] focus:ring-2 focus:ring-[#8A5A44]/20 focus:border-[#8A5A44] outline-none transition-all";

export function StatusPill({ status, map }) {
  const s = map[status] || { label: status, cls: "bg-[#F0EFEA] text-[#5C5B57]" };
  return <span className={`inline-block text-xs px-2.5 py-1 rounded-full font-medium ${s.cls}`}>{s.label}</span>;
}
